/** Full-bleed tab favicon PNGs — no tile radius (Chrome/Safari already mask). */
export const BRAND_LOGO_LIGHT_SRC: string = "/brand/favicon-light.png";

export const BRAND_LOGO_DARK_SRC: string = "/brand/favicon-dark.png";

/** SVG mark — dark tile + white triangle (`logo-dark.svg`). */
export const BRAND_LOGO_DARK_MARK_SRC: string = "/brand/logo-dark.svg";

export const BRAND_FAVICON_LINK_ATTR: string = "data-brand-favicon";

export function resolveBrandFaviconHref(isDark: boolean): string {
  return isDark ? BRAND_LOGO_DARK_SRC : BRAND_LOGO_LIGHT_SRC;
}

/** Mirrors `next-themes` storage + system preference (client-only). */
export function resolveIsDarkFromThemeStorage(): boolean {
  const stored: string | null = localStorage.getItem("theme");
  if (stored === "dark") return true;
  if (stored === "light") return false;
  return window.matchMedia("(prefers-color-scheme: dark)").matches;
}

export function applyBrandFaviconLink(isDark: boolean): void {
  const href: string = resolveBrandFaviconHref(isDark);
  let link: HTMLLinkElement | null = document.querySelector<HTMLLinkElement>(
    `link[${BRAND_FAVICON_LINK_ATTR}]`,
  );
  if (link == null) {
    link = document.createElement("link");
    link.rel = "icon";
    link.type = "image/png";
    link.setAttribute(BRAND_FAVICON_LINK_ATTR, "");
    document.head.appendChild(link);
  }
  const absoluteHref: string = new URL(href, window.location.origin).href;
  if (link.href !== absoluteHref) link.href = href;
  // Re-append so this icon wins over metadata siblings without removing them.
  document.head.appendChild(link);
  // Do not remove other <link rel="icon"> nodes — Next.js manages metadata icons
  // in React's head tree; imperative removal causes react-dom removeChild crashes.
}
